import React ,{ useState } from 'react';
import { ApiGetShopperPopUpDetails } from "../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";

export interface ShopperDetailsData {
  userId?: number;
  firstName?: string;
  lastName?: string;
  contactDetails?: {
    age: string;
    email: string;
    phone: string;
  };
  currentMonthAllocationCounts?: {
    MM: number;
    BLOOMS: number;
    ALDI: number;
    TRANSPORT: number;
  };
  shopperOtherDetail?: {
    shopperNotes: string;
    trainingNotes: string;
  };
  lastReportRatingData?: {
    MM?: any;
    ALDI?: any;
    BLOOMS?: any;
  };
  totalReportCounts?: {
    total: number;
    ALDI: number;
    BLOOMS: number;
    MM: number;
    beacon: number;
    totalLastMonthReportCounts: number;
  };
  createdOn?: string;
  shopperOverAllRating?: string;
}

export interface ShopperDetailsHook {
  anchorEl: HTMLElement | null;
  loanData: ShopperDetailsData | null;
  clickedShopperId: number | null;
  handleShopperDetailsClick: (event: React.MouseEvent, userId?: number) => Promise<void>;
  handleClose: () => void;
}

export const useShopperDetails = (): ShopperDetailsHook => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [loanData, setLoanData] = useState<ShopperDetailsData | null>(null);
  const [clickedShopperId, setClickedShopperId] = useState<number | null>(null);

  const handleShopperDetailsClick = async (event: React.MouseEvent, userId?: number): Promise<void> => {
    if (!userId) return;

    setAnchorEl(event.currentTarget as HTMLElement);
    setClickedShopperId(userId);
    
    try {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();

      const data = `?userId=${userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

      const response = await ApiGetShopperPopUpDetails(data);

      if (!response.status) {
        toast.error("Failed to load shopper details");
        return;
      }

      setLoanData(response.data);
    } catch (error) {
      console.error("Error loading shopper details:", error);
      toast.error("Error loading shopper details");
    }
  };

  const handleClose = (): void => {
    setAnchorEl(null);
    setClickedShopperId(null);
  };

  return {
    anchorEl,
    loanData,
    clickedShopperId,
    handleShopperDetailsClick,
    handleClose
  };
};